import { render, staticRenderFns } from "./CustomerMRList.vue?vue&type=template&id=cbdea8a6"
import script from "./CustomerMRList.vue?vue&type=script&lang=ts"
export * from "./CustomerMRList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports